<template>
  <b-modal ref="bills"
           size="xl"
           :hide-footer="true"
           scrollable
           @hide="$emit('hide')"
  >
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.Bills.Title}}
        </span>
        <button class="close" @click="onClose">x</button>
      </div>
    </template>
    <div class="d-flex flex-wrap" style="height: calc(100% - 128px);">
      <div class="d-flex justify-content-end w-100" style="height: 35px;">
        <i class="fas fa-file-excel text-third" style="font-size: 24px;" @click="exportExcel" v-b-tooltip.hover.topleft :title="'Exportar Excel'"></i>
      </div>
      <ag-grid-vue class="ag-theme-alpine"
                   :getLocaleText="localeTextFunc"
                   :defaultColDef="defaultColumnDef"
                   :gridOptions="billsGridOptions"
                   :columnTypes="columnTypes"
                   :columnDefs="columnDefs"
                   :rowData="data"
                   suppressContextMenu
                   suppressHorizontalScroll
                   :excelStyles="billsExcelStyles"
                   stopEditingWhenCellsLoseFocus
                   :groupHeaderHeight="45"
                   :headerHeight="45"
                   :rowHeight="30"
                   style="width:100%;height:100%;"
      >
      </ag-grid-vue>
    </div>
    <div class="d-flex flex-wrap align-items-center" style="height: 128px;">
      <div class="col-4"></div>
      <div class="col-2 mt-1 pt-2 align-items-center">
        <b-form-group :label="$lang.PCI.Bills.LabelPaidOut" label-cols="4" label-align="right" content-cols="8">
          <b-form-input :disabled="true" v-model="ammountPaid" class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang.PCI.Bills.LabelPayable" label-cols="4" label-align="right" content-cols="8">
          <b-form-input :disabled="true" v-model="ammountToPay" class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang.PCI.Bills.LabelTotal" label-cols="4" label-align="right" content-cols="8">
          <b-form-input :disabled="true" v-model="totalValue" class="text-right"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-2 mt-1 pt-2 align-items-center">
        <b-form-group :label="$lang.PCI.Bills.LabelConstruction" label-cols="4" label-align="right" content-cols="8">
          <b-form-input :disabled="true" v-model="construction" class="text-center"></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang.PCI.Bills.LabelClientReference" label-cols="4" label-align="right" content-cols="8">
          <b-form-input :disabled="true" v-model="client" class="text-center"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-4"></div>
    </div>
  </b-modal>
</template>

<script>
import ZSistemaRepository from '@/shared/http/repositories/business/zsystem'
import { loading } from '@/shared/utils/UIHelper'
import gridMixin from '../../mixins/gridMixin'
import { AgGridVue } from 'ag-grid-vue'

export default {
  name: 'Bills',
  components: {
    AgGridVue
  },
  mixins: [gridMixin],
  computed: {
    ammountPaid () {
      const sumValue = this.data.filter(d => d.situacao === 'PAGO').reduce((acc, curr) => acc + curr.valorPago, 0.00)
      return sumValue.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    ammountToPay () {
      const sumValue = this.data.filter(d => d.situacao !== 'PAGO').reduce((acc, curr) => acc + curr.valorPago, 0.00)
      return sumValue.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    totalValue () {
      const sumValue = this.data.reduce((acc, curr) => acc + curr.valorPago, 0.00)
      return sumValue.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    construction () {
      return this.data.length ? this.data[0].obra : ''
    },
    client () {
      return this.data.length ? this.data[0].referenciaCliente : ''
    }
  },
  data () {
    return {
      data: [],
      billsGridOptions: {},
      billsExcelStyles: [],
      defaultColumnDef: {
        filter: 'agSetColumnFilter',
        floatingFilter: false,
        resizable: true,
        editable: false,
        suppressMenu: false,
        sortable: true,
        enableRowGroup: true,
        width: 100,
        minWidth: 80
      },
      columnDefs: [
        {
          headerName: this.$lang.PCI.Bills.Datatable.Request,
          field: 'pedido',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Security,
          field: 'titulo',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.IssueDate,
          field: 'dataEmissao',
          type: 'dateColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.DueDate,
          field: 'dataVencimento',
          type: 'dateColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Value,
          field: 'valor',
          type: 'numberColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Penalty,
          field: 'valorMulta',
          type: 'numberColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Discount,
          field: 'valorDesconto',
          type: 'numberColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Tax,
          field: 'valorImposto',
          type: 'numberColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Liquid,
          valueGetter: params => (params.data.valor + params.data.valorMulta - params.data.valorDesconto + params.data.valorImposto),
          type: 'numberColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Payment,
          field: 'dataPagamento',
          type: 'dateColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.PaidOut,
          field: 'valorPago',
          type: 'numberColumn',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Check,
          field: 'cheque',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Provider,
          field: 'fornecedor',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.CorporateName,
          field: 'nome',
          flex: 100
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.PCG,
          field: 'pcg',
          flex: 20
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.PCGDescription,
          field: 'pcgDescricao',
          flex: 50
        },
        {
          headerName: this.$lang.PCI.Bills.Datatable.Situation,
          field: 'situacao',
          flex: 20
        }
      ]
    }
  },
  methods: {
    show (obraID) {
      this.billsExcelStyles = [...this.excelStyles,
        {
          id: 'title',
          alignment: {
            vertical: 'Center'
          },
          interior: {
            color: '#046437',
            pattern: 'solid'
          },
          font: {
            bold: true,
            color: '#FFFFFF',
            size: 18
          }
        },
        {
          id: 'footer',
          font: {
            bold: true
          }
        }
      ]
      loading.push()
      ZSistemaRepository.GetAllBills(obraID)
        .then(response => {
          if (response.data.code > 0) {
            this.data = response.data.data
            this.$refs.bills.show()
          }
        })
        .finally(() => loading.close())
    },
    exportExcel () {
      const paidValue = this.data.filter(d => d.situacao === 'PAGO').reduce((acc, curr) => acc + curr.valorPago, 0.00)
      const toPayValue = this.data.filter(d => d.situacao !== 'PAGO').reduce((acc, curr) => acc + curr.valorPago, 0.00)
      const totalValue = this.data.reduce((acc, curr) => acc + curr.valorPago, 0.00)
      const append = () => ({
        prependContent: [
          {cells: [
            {data: {value: '', type: 'String'}, styleId: 'title', mergeAcross: 16}
          ]},
          {cells: [
            {data: {value: 'Contas a Pagar', type: 'String'}, styleId: 'title', mergeAcross: 16}
          ]},
          {cells: [
            {data: {value: '', type: 'String'}, styleId: 'title', mergeAcross: 16}
          ]}
        ],
        appendContent: [
          {cells: []},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'Pago', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: paidValue, type: 'Number'}, styleId: ['floatType', 'footer']},
            {data: {value: 'Obra', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: this.data[0].obra, type: 'String'}, styleId: 'footer'}
          ]},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'À Pagar', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: toPayValue, type: 'Number'}, styleId: ['floatType', 'footer']},
            {data: {value: 'Ref.Cliente', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: this.data[0].referenciaCliente, type: 'String'}, styleId: 'footer'}
          ]},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'Total', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: totalValue, type: 'Number'}, styleId: ['floatType', 'footer']}
          ]}
        ]
      })
      this.billsGridOptions.api.exportDataAsExcel(append())
    },
    onClose () {
      this.$refs['bills'].hide()
      this.$emit('update', this.data)
    }
  }
}
</script>

<style scoped>
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow: hidden;
}
* >>> .modal-footer {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
* >>> .modal-content {
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/bills/bills.vue